import {BaseApiService} from "../../../infrastructure/domain-services/base-api-service";

export class H2hApiService extends BaseApiService {}